// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__z3zco","mod-background":"Image_mod-background__QvHmS","mod-portrait":"Image_mod-portrait__paLIi"};